import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-regular-svg-icons'
import {
  faStar as solidStar,
  faStarHalfAlt,
} from '@fortawesome/free-solid-svg-icons'
import { ColorEnum } from 'enum'

export const Stars = (
  star: number,
  color: string = ColorEnum.GOLD,
): JSX.Element[] => {
  const starsArray: JSX.Element[] = []
  if (isNaN(star)) return starsArray

  star = Math.floor(star * 10) / 10
  let flooredStar = Math.floor(star)
  let decimal = (star * 10) % 10
  /*
  x < 4.3 => 4
  4.3 <= x < 4.7 => 4.5
  x > 4.7 => 5
  */
  decimal = decimal > 7 ? 1 : decimal >= 3 ? 0.5 : 0
  star = flooredStar + decimal
  if (decimal === 1) {
    flooredStar++
  }
  for (let i = 0; i < flooredStar; i++) {
    starsArray.push(
      <FontAwesomeIcon icon={solidStar} size="sm" style={{ color: color }} />,
    )
  }
  if (decimal === 0.5) {
    starsArray.push(
      <FontAwesomeIcon
        icon={faStarHalfAlt}
        size="sm"
        style={{ color: color }}
      />,
    )
    flooredStar++
  }
  for (let i = flooredStar; i < 5; i++) {
    starsArray.push(
      <FontAwesomeIcon icon={faStar} size="sm" style={{ color: color }} />,
    )
  }
  return starsArray
}
